import { z } from "zod";

// Schemas

export const AttachmentTypeSchema = z.enum(["editable", "original", "signed"]);

export const AttachmentSchema = z.object({
  /** The type of attachment. */
  attachmentType: AttachmentTypeSchema,
  /** If the attachment is a raw url. */
  isUrl: z.boolean().optional(),
  /** The name of the file when uploaded (includes the file extension), or "URL" when a url is
   * used instead. Inferred from the File object during upload. */
  name: z.string(),
  /** A url to the uploaded file, or the url directly assigned. */
  url: z.string(),
  /** The path to the uploaded file in the cloud bucket. */
  path: z.string(),
  /** The file's mimetype, as inferred from the File object during upload. */
  mimeType: z.string().optional(),
  /** The file's extension (without the dot). */
  extension: z.string().optional(),
  /** The size of the file in bytes. */
  sizeBytes: z.number().optional(),
  /** A random uuid distinguishing attachments. Used in the bucket path. */
  attachmentId: z.string(),
});
